/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},

  APPEAL_APPLICATION_SUCCESS: {
    message: 'Application drafted Successfully',
  },
  APPEAL_APPLICATION_ERROR: {
    message: 'Failed to draft application',
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.jamaica.workPermitDraft',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        MUTATE: { target: 'INITIATE_APPEAL_APPLICATION' },
      },
    },
    INITIATE_APPEAL_APPLICATION: {
      invoke: {
        id: 'appealApplication',
        src: 'appealApplication',
        onDone: {
          target: 'APPEAL_APPLICATION_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'APPEAL_APPLICATION_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    APPEAL_APPLICATION_SUCCESS: {
      // type: 'final',
      on: {
        TRIGGER_REFRESH: {
          target: 'idle',
        },

        // MUTATE: { target: 'INITIATE_APPEAL_APPLICATION' },
      },
    },
    APPEAL_APPLICATION_ERROR: {
      type: 'final',
      // on: {
      //   MUTATE: { target: 'INITIATE_APPEAL_APPLICATION' },
      // },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
